import axiosInstance from '../../utils/axios';
import { getVideo } from './videoAPI';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  video: {},
  isLoading: false,
  isError: false,
  error: '',
};

// async thunk
export const fetchVideo = createAsyncThunk('video/fetchVideo', async (id) => {
  const video = await getVideo(id);
  return video;
});

//add like
export const updateVideo = createAsyncThunk(
  'videos/updateVideos',
  async (video) => {
    await axiosInstance.put(`/videos/${video.id}`, {
      ...video,
      likes: video.likes + 1,
    });

    return {
      ...video,
      likes: video.likes + 1,
    };
  }
);
export const updateVideoUnlike = createAsyncThunk(
  'videos/updateVideos',
  async (video) => {
    await axiosInstance.put(`/videos/${video.id}`, {
      ...video,
      unlikes: video.unlikes + 1,
    });

    return {
      ...video,
      unlikes: video.unlikes + 1,
    };
  }
);

const videoSlice = createSlice({
  name: 'video',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideo.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.video = action.payload;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.video = {};
        state.isError = true;
        state.error = action.error?.message;
      });
    // update
    builder.addCase(updateVideo.rejected, (state, action) => {
      console.log(action.error);
    });
    builder.addCase(updateVideo.fulfilled, (state, action) => {
      console.log(action.payload.id);

      state.video = action.payload;
    });
  },
  // reducers: {
  //   addLike: (state, action) => {
  //     state.video.likes += 1;
  //   },
  //   addUnlike: (state, action) => {
  //     state.video.unlikes += 1;
  //   },
  // },
});

export default videoSlice.reducer;
export const { addLike, addUnlike } = videoSlice.actions;
